import React from 'react';
import i18n from '../i18n';
import {Trans} from 'react-i18next';

const BorderWidthConfigs = [
  {
    value: '0',
    label: (
      <div>
        <Trans i18nKey="u.c.skincare.detection.none">None</Trans>
      </div>
    ),
  },
  {
    value: '1px',
    label: <div className="landingoption landingoption__1px">1px</div>,
  },
  {
    value: '2px',
    label: <div className="landingoption landingoption__2px">2px</div>,
  },
  {
    optionClassName: 'landingoption__3px',
    value: '3px',
    label: <div className="landingoption landingoption__3px">3px</div>,
  },
  {
    value: '4px',
    label: <div className="landingoption landingoption__4px">4px</div>,
  },
  {
    value: '5px',
    label: <div className="landingoption landingoption__5px">5px</div>,
  },
  {
    value: '6px',
    label: <div className="landingoption landingoption__6px">6px</div>,
  },
];

const BorderStyleConfigs = [
  {
    label: <div className="landingoption-style landingoption__solid" />,
    value: 'solid',
  },
  {
    label: <div className="landingoption-style landingoption__dashed" />,
    value: 'dashed',
  },
  {
    label: <div className="landingoption-style landingoption__dotted" />,
    value: 'dotted',
  },
  {
    label: <div className="landingoption-style landingoption__double" />,
    value: 'double',
  },
  {
    value: 'none',
    label: <Trans i18nKey="u.c.skincare.detection.none">None</Trans>,
  },
];
export default {
  getBorderStyleConfigs: () => BorderStyleConfigs,
  getBorderWidthConfigs: () => BorderWidthConfigs,
};
